import React from "react";
import "./CardVacancy.scss";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as Star } from "../../../../../images/search_profession/nav_bar-star.svg";
import hh_icon from "../../../../../images/icons/hh_icon.svg";
import trud_vsem_icon from "../../../../../images/icons/trud_vsem-icon.svg";
import { setActiveVacancy } from "../../../../../redux/actions/searchProfessionActions";
import { defaultFuncAndData } from "../../../../utils/defaultData";
import SkillBlockVacancy from "../../ReuseComponents/SkillBlockVacancy";
function CardVacancySection({
  vacancy,
  userSkills,
  handleAddSkillTraektory,
  setCoordsTagAnimation,
  handleChangeFavoriteVacancy,
  favoriteVacancy,
  isLightTheme,
}) {
  const { activeVacancy } = useSelector((state) => state.SearchProfession);
  const dispatch = useDispatch();
  const isActive = activeVacancy?.id === vacancy?.id;
  return (
    <li
      // className={s.card + (isActive ? s.target : "")}
      className={`card_vacancyc ${isActive ? "target" : ""}`}
      onClick={() => {
        dispatch(setActiveVacancy(null));
        setTimeout(() => {
          dispatch(setActiveVacancy(vacancy));
        }, 300);
      }}
    >
      <div className={"header"} id={vacancy?.id}>
        <span>{vacancy?.name}</span>
        <div className={"title_vacancy"}>
          <div className={"wrapper_link"}>
            <a
              href={vacancy?.alternate_url}
              className={"header_link"}
              target="_blank"
              rel="noopener noreferrer"
            >
              Открыть на
            </a>
            <img
              src={
                vacancy.alternate_url.includes("hh.ru")
                  ? hh_icon
                  : trud_vsem_icon
              }
              alt="hh_icon"
            />
          </div>
          <div className={"star_back"}>
            <Star
              width={14}
              height={14}
              onClick={(e) => {
                e.stopPropagation();
                handleChangeFavoriteVacancy(vacancy);
              }}
              className={
                defaultFuncAndData.calcActiveFavoriteIcon(
                  vacancy,
                  favoriteVacancy
                )
                  ? "active"
                  : ""
              }
            />
          </div>
        </div>
      </div>
      <div className={"salary"}>
        {defaultFuncAndData.calcSalarysVacancy(vacancy)} &nbsp;
        {/* <span>{vacancy?.salary?.to}</span>&nbsp; - &nbsp;
    <span>{vacancy?.salary?.from}</span> &nbsp; &nbsp; */}
        <span>{vacancy?.employer?.name}</span>
      </div>
      <SkillBlockVacancy
        userSkills={userSkills || []}
        needSkillsThisVacansy={(vacancy && vacancy.skills) || []}
        addSkillTraektory={(skill) => handleAddSkillTraektory(skill, true)}
        setCoordsTagAnimation={(e) => setCoordsTagAnimation(e)}
        needAnimation={true}
        isLightTheme={isLightTheme}
      />
    </li>
  );
}

export default CardVacancySection;
